var map = {
	"./search-results.de-CH.json": 993,
	"./search-results.de-DE.json": 994,
	"./search-results.en-CA.json": 995,
	"./search-results.en-GB.json": 996,
	"./search-results.en-IN.json": 997,
	"./search-results.en-ME.json": 998,
	"./search-results.en-US.json": 999,
	"./search-results.es-EM.json": 1000,
	"./search-results.es-ES.json": 1001,
	"./search-results.fr-BE.json": 1002,
	"./search-results.fr-CA.json": 1003,
	"./search-results.fr-CH.json": 1004,
	"./search-results.nl-BE.json": 1005,
	"./search-results.nl-NL.json": 1006,
	"./search-results.pl-PL.json": 1007,
	"./search-results.pt-BR.json": 1008
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 992;